import styled from 'styled-components';
import { colors } from '@chegg-ui/theme';
export var PaddedContainer = styled.div.withConfig({
  componentId: "sc-1plyd2l-0"
})(["margin-bottom:20px;display:flex;align-items:center;"]);
export var Divider = styled.hr.withConfig({
  componentId: "sc-1plyd2l-1"
})(["color:", ";margin-bottom:20px;"], colors.greyXlight);
export var CardViewWrapper = styled.div.withConfig({
  componentId: "sc-1plyd2l-2"
})(["", ""], function (_ref) {
  var isHidden = _ref.isHidden;
  return isHidden && 'display:none';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/CardFormView/styled.js
// module id = 1506
// module chunks = 11